import en from './en/translation';
import tr from './tr/translation';

export default {
  en: {
    translation: en,
  },
  tr: {
    translation: tr,
  },
};
